import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Link, useLocation } from 'react-router'
import { cn, getUserImgSrc } from '#app/utils/misc.tsx'
import { useUser } from '#app/utils/user.ts'
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar.tsx'
import { Button } from './ui/button.tsx'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu.tsx'

function UserMenu() {
  const user = useUser()
  const formRef = useRef<HTMLFormElement>(null)
  const { t } = useTranslation()
  const location = useLocation()

  const firstName = user.firstName

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button asChild variant="avatar" size="xs" aria-label={firstName}>
          <Link
            to={'/account'}
            // this is for progressive enhancement
            onClick={e => e.preventDefault()}
            className="flex items-center gap-2"
          >
            <Avatar>
              {user.image && (
                <AvatarImage src={getUserImgSrc(user.image?.id)} alt="" />
              )}
              <AvatarFallback>{firstName?.slice(0, 1)}</AvatarFallback>
            </Avatar>
          </Link>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuPortal>
        <DropdownMenuContent sideOffset={8} align="end">
          <DropdownMenuItem asChild>
            <Link
              className={cn(
                location.pathname.includes('/account') && 'font-medium',
              )}
              prefetch="intent"
              to="/account"
            >
              {t('account.title')}
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link
              className={cn(
                location.pathname.includes('/enrollments/create') &&
                  'font-medium',
              )}
              prefetch="intent"
              to="/enrollments/create"
            >
              {t('addEnrollment.title')}
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <Form action="/sign-out" method="POST" ref={formRef}>
            <DropdownMenuItem asChild>
              <button type="submit" className="w-full">
                {t('signOut')}
              </button>
            </DropdownMenuItem>
          </Form>
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  )
}

export { UserMenu }
